module.exports = __webpack_public_path__ + "img/call-types-all.aa42a7ce.svg";